import React, { useState } from 'react'
import { api } from '../api/client'
import Button from './Button'
import { Card, InlineAlert, PageHeader } from './ui'
import { SETUP_GUIDE_LABEL, SETUP_GUIDE_URL } from '../helpLinks'
import '../styles/connector-auth.css'

// Коннекторы, подключаемые по OAuth: кнопка ведёт на страницу авторизации
// сервиса, само подключение создаётся в OAuth-callback на бэкенде. getUrl —
// метод api-клиента, возвращающий { url }.
//
// Токеновых коннекторов в продукте сейчас нет (iiko / Мой склад скрыты из
// галереи, см. HIDDEN_SLUGS в ConnectorGallery, и для них нет бэкенд-эндпоинта
// создания подключения). Когда появится первый токеновый коннектор — добавлять
// отдельную ветку вместе с реальным бэкенд-эндпоинтом, а не оживлять старую
// форму, которая дёргала несуществующий api.createConnection.
const OAUTH_CONNECTORS = {
  bitrix24: {
    getUrl: () => api.getBitrix24OauthUrl(),
    desc: 'Нажмите кнопку ниже — вы будете перенаправлены на страницу авторизации Битрикс24. После подтверждения доступ будет настроен автоматически.',
    btn: 'Войти через Битрикс24'
  },
  amocrm: {
    getUrl: () => api.getOauthUrl(),
    desc: 'Нажмите кнопку ниже — вы будете перенаправлены на страницу авторизации amoCRM. После подтверждения доступа вебхук зарегистрируется автоматически.',
    btn: 'Войти через amoCRM'
  }
}

function OAuthAuth ({ connector, config, onBack }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function handleConnect () {
    setError(null)
    setLoading(true)
    try {
      const { url } = await config.getUrl()
      window.location.href = url
    } catch (err) {
      setError(err.message)
      setLoading(false)
    }
  }

  return (
    <div className='connector-auth'>
      <Button variant='ghost' className='connector-auth__back' onClick={onBack}>← Назад</Button>

      <Card className='connector-auth__card' aria-label={`Подключение ${connector.name}`}>
        <PageHeader title={`Подключить ${connector.name}`} description={config.desc} />

        {error && <InlineAlert tone='error'>{error}</InlineAlert>}

        <div className='connector-auth__actions'>
          <Button onClick={handleConnect} loading={loading}>
            {loading ? 'Перенаправление…' : config.btn}
          </Button>
        </div>

        <p className='connector-auth__note'>
          Connector Hub запросит доступ к сделкам CRM. Токены хранятся в зашифрованном виде.{' '}
          <a
            className='connector-auth__guide'
            href={SETUP_GUIDE_URL}
            target='_blank'
            rel='noopener noreferrer'
          >
            {SETUP_GUIDE_LABEL}
          </a>
        </p>
      </Card>
    </div>
  )
}

export default function ConnectorAuth ({ connector, onBack }) {
  const oauthConfig = OAUTH_CONNECTORS[connector.slug]

  if (!oauthConfig) {
    // Сюда не должны попадать: галерея показывает только OAuth-коннекторы,
    // а ConnectorConnect отдаёт «не найден» для неизвестных slug. Явная
    // заглушка вместо тихого падения, если инвариант нарушат.
    return (
      <div className='connector-auth'>
        <Button variant='ghost' className='connector-auth__back' onClick={onBack}>← Назад</Button>
        <Card className='connector-auth__card' aria-label={`Подключение ${connector.name}`}>
          <PageHeader title={`Подключить ${connector.name}`} />
          <InlineAlert tone='error'>
            Этот коннектор пока нельзя подключить через интерфейс.
          </InlineAlert>
        </Card>
      </div>
    )
  }

  return <OAuthAuth connector={connector} config={oauthConfig} onBack={onBack} />
}
